import clsx from "clsx";
import type { FC, ReactNode } from "react";
import { useMemo } from "react";
import classes from "./Gamepad.module.scss";

export interface GamepadProps {
	id?: number;
	title: string;
	image: string;
	children: ReactNode;
	className?: string;
}

export interface GamepadComponent extends FC<GamepadProps> {}

export const Gamepad: GamepadComponent = ({
	title,
	children,
	image,
	className,
}) => {
	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	return (
		<div className={wrapperClassName}>
			<div className={classes.content}>
				<h4 className={classes.title}>{title}</h4>
				<h6 className={classes.text}>{children}</h6>
			</div>
			<img className={classes.image} src={image} alt="" />
		</div>
	);
};
